var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status == 1)?_c('v-chip',{attrs:{"color":"success","text-color":"white"}},[_vm._v("Yes")]):(_vm.status == 0)?_c('v-chip',{attrs:{"color":"red","text-color":"white"}},[_vm._v("No")]):_c('v-chip',[_vm._v("Unknown")])
}
var staticRenderFns = []

export { render, staticRenderFns }